import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Axios from "axios";
import "bulma/css/bulma.css";
import "@fortawesome/fontawesome-free/css/all.css";

Vue.prototype.$http = Axios;
const token = localStorage.getItem("token");

if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] =
    "Bearer " + token;
}

Vue.config.productionTip = process.env.VUE_APP_PRODUCTION_TIP;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
